import * as React from 'react';
import styled from 'styled-components';

export const Amazon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="106" height="32" viewBox="0 0 106 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.8 25c-6.2 4.5-15.1 7-22.8 7 -10.8 0-20.5-4-27.8-10.6 -0.6-0.5-0.1-1.2 0.6-0.8 7.9 4.6 17.7 7.4 27.8 7.4 6.8 0 14.3-1.4 21.2-4.3C65.9 23.1 66.8 24.3 65.8 25"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.3 22.1c-0.8-1-5.2-0.5-7.2-0.2 -0.6 0.1-0.7-0.5-0.2-0.8 3.5-2.5 9.3-1.8 10-0.9 0.7 0.8-0.2 6.6-3.5 9.4 -0.5 0.4-1 0.2-0.8-0.4C67.4 27.3 69.1 23.1 68.3 22.1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.3 3.5V1.1c0-0.4 0.3-0.6 0.6-0.6h10.8c0.3 0 0.6 0.2 0.6 0.6v2.1c0 0.3-0.3 0.8-0.8 1.5l-5.6 8c2.1-0.1 4.3 0.3 6.2 1.3 0.4 0.2 0.5 0.6 0.6 0.9v2.6c0 0.4-0.4 0.8-0.8 0.6 -3.3-1.7-7.7-1.9-11.4 0 -0.4 0.2-0.8-0.2-0.8-0.6v-2.4c0-0.4 0-1.1 0.4-1.7l6.5-9.3h-5.6C61.5 4.1 61.3 3.9 61.3 3.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9 18.5h-3.3c-0.3 0-0.6-0.3-0.6-0.6V1.1c0-0.3 0.3-0.6 0.6-0.6h3.1c0.3 0 0.6 0.3 0.6 0.6v2.2h0.1c0.8-2.1 2.3-3.1 4.3-3.1 2.1 0 3.3 1 4.3 3.1 0.8-2.1 2.6-3.1 4.5-3.1 1.4 0 2.9 0.6 3.8 1.8 1 1.4 0.8 3.5 0.8 5.3l0 10.6c0 0.3-0.3 0.6-0.6 0.6h-3.3c-0.3 0-0.6-0.3-0.6-0.6V9c0-0.7 0.1-2.5-0.1-3.2 -0.2-1.1-1-1.5-1.9-1.5 -0.8 0-1.6 0.5-2 1.4C31.3 6.6 31.4 8 31.4 9v8.9c0 0.3-0.3 0.6-0.6 0.6h-3.3c-0.3 0-0.6-0.3-0.6-0.6l0-8.9c0-1.9 0.3-4.7-2-4.7 -2.4 0-2.3 2.7-2.3 4.7v8.9C22.6 18.3 22.3 18.5 21.9 18.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.6 0.2c-4.7 0-7.4 4.1-7.4 9.3 0 5.2 2.6 9.4 7.4 9.4 4.6 0 7.5-4.1 7.5-9.2C90.1 4.3 87.4 0.2 82.6 0.2zM82.6 15.4C80 15.4 80 11 80 9c0-2.1 0.2-5.4 2.6-5.4 1 0 1.8 0.5 2.1 1.6 0.4 1.3 0.5 3.1 0.5 4.5C85.2 11.9 85.1 15.4 82.6 15.4z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.4 18.5h-3.3c-0.3 0-0.6-0.3-0.6-0.6l0-16.9c0-0.3 0.3-0.6 0.6-0.6h3c0.3 0 0.5 0.2 0.6 0.5v2.6h0.1c0.9-2.3 2.2-3.4 4.5-3.4 1.5 0 2.9 0.5 3.8 2 0.9 1.3 0.9 3.6 0.9 5.3V18c0 0.3-0.3 0.5-0.6 0.5h-3.3c-0.3 0-0.5-0.2-0.6-0.5V8.9c0-1.8 0.2-4.5-2.1-4.5 -0.8 0-1.5 0.5-1.9 1.3 -0.5 1-0.5 2.1-0.5 3.2v9.1C97 18.3 96.7 18.5 96.4 18.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.5 15.5c-0.6-0.8-1.2-1.5-1.2-3V7.3c0-2.2 0.2-4.2-1.4-5.7C54.6 0.4 52.5 0 50.9 0c-3.1 0-6.6 1.2-7.3 5 -0.1 0.4 0.2 0.6 0.5 0.7l3.2 0.3c0.3 0 0.5-0.3 0.6-0.6 0.3-1.3 1.4-2 2.6-2 0.7 0 1.4 0.2 1.8 0.9 0.5 0.7 0.4 1.6 0.4 2.4v0.4c-1.9 0.2-4.4 0.4-6.2 1.1C44.4 9.2 43 11 43 13.7c0 3.4 2.1 5.1 4.9 5.1 2.3 0 3.6-0.6 5.4-2.4 0.6 0.9 0.8 1.3 1.9 2.2 0.2 0.1 0.6 0.1 0.8-0.1l0 0c0.7-0.6 1.8-1.6 2.5-2.2C58.8 16.1 58.7 15.8 58.5 15.5zM52.1 14c-0.5 0.9-1.4 1.5-2.3 1.5 -1.3 0-2-1-2-2.4 0-2.8 2.5-3.3 4.9-3.3v0.7C52.7 11.8 52.7 12.8 52.1 14z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 15.5c-0.6-0.8-1.2-1.5-1.2-3V7.3c0-2.2 0.2-4.2-1.4-5.7C11.6 0.4 9.5 0 7.9 0 4.8 0 1.3 1.2 0.5 5 0.5 5.4 0.8 5.7 1 5.7l3.2 0.3c0.3 0 0.5-0.3 0.6-0.6 0.3-1.3 1.4-2 2.6-2 0.7 0 1.4 0.2 1.8 0.9C9.7 5 9.7 5.9 9.7 6.7v0.4C7.8 7.4 5.3 7.5 3.5 8.3 1.4 9.2 0 11 0 13.7c0 3.4 2.2 5.1 4.9 5.1 2.3 0 3.6-0.6 5.4-2.4 0.6 0.9 0.8 1.3 1.9 2.2 0.2 0.1 0.6 0.1 0.8-0.1l0 0c0.7-0.6 1.8-1.6 2.5-2.2C15.8 16.1 15.7 15.8 15.5 15.5zM9.1 14c-0.5 0.9-1.3 1.5-2.3 1.5 -1.3 0-2-1-2-2.4 0-2.8 2.5-3.3 4.9-3.3v0.7C9.7 11.8 9.7 12.8 9.1 14z"
    />
  </svg>
);

export default styled(Amazon)`
  & > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
